<template>
  <v-container  class="px-sm-8 py-0 pa-md-0">
    <v-row no-gutters align="start" justify="start">
      <v-col cols="5" sm="3" md="2" offset-md="1" class="mb-8 mb-md-0">
        <a
          href="https://asia.fes.de/"
          target="_blank">
          <img src="@/assets/fes-logo.svg" width="100%" style="margin: 0 auto; display: block;"/>
        </a>
      </v-col>

      <v-col cols="12" md="7" offset-md="1">
        <p class="text-body font-weight-bold text--fes-blue mb-8">
          Friedrich-Ebert-Stiftung (FES) is the oldest of Germany’s political foundations. Founded in 1925, FES is named after Friedrich Ebert, the first democratically elected president of Germany. FES is committed to the advancement of both socio-political and economic development in the spirit of social democracy, through civic education, research and international cooperation.
        </p> 
        <p class="text-body text--fes-blue mb-8">
          A social-ecological transformation that promotes low-emission, resource-efficient and socially inclusive economies is among the goals of FES in the field of climate and energy in Asia. As a social-democratic foundation, we are particularly committed to ensuring that the social question is given due consideration in the context of transformation.
        </p>        
        <p class="text-body text--fes-blue mb-8">
          The Regional Climate and Energy Project in Asia works with its partners and colleagues towards a social-ecological transformation in the region. It is based in Hanoi, Vietnam, and advocates for greater climate justice through its network in five different countries in Asia.
        </p>

        <p class="text-body font-weight-bold text--fes-blue mb-8">
          Do you want to help us grow our map? Send us your pitch at <a href="mailto: info.orca@fes.de" target="_blank">info.orca@fes.de</a>
        </p>

        <SocialIcons class="mb-8" />
        <p class="text-nav-anchor font-secondary font-weight-light text--fes-blue text-center text-md-left mb-0">FES Asia 2021. All rights reserved.</p>
      </v-col>          
    </v-row>
  </v-container>       
</template>

<script>
import SocialIcons from '@/components/layout/SocialIcons'

export default {
  name: 'Footer',
  components: {
    SocialIcons,
  },
}
</script>
